if (!customElements.get('sokynd-cart-timer')) {
  const storageKey = 'sokynd-cart-countdown-end';
  let memoryDeadline = null;

  customElements.define('sokynd-cart-timer', class extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.events = new AbortController();
      this.drawer?.addEventListener('on:cart-drawer:before-open', () => this.startCountdown(), { signal: this.events.signal });
      this.drawer?.addEventListener('on:cart:after-merge', () => this.onCartMerge(), { signal: this.events.signal });
      this.observer = new MutationObserver(() => {
        if (this.drawer.hasAttribute('open')) this.startCountdown();
        else this.stopInterval();
      });
      if (this.drawer) this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['open'] });
      this.onCartMerge();
    }

    readDeadline() {
      try {
        const stored = Number(window.sessionStorage.getItem(storageKey));
        if (Number.isFinite(stored) && stored > 0) return stored;
      } catch (error) {}
      return memoryDeadline;
    }

    saveDeadline(deadline) {
      memoryDeadline = deadline;
      try {
        if (deadline === null) window.sessionStorage.removeItem(storageKey);
        else window.sessionStorage.setItem(storageKey, String(deadline));
      } catch (error) {}
    }

    onCartMerge() {
      if (Number(this.dataset.cartCount) === 0) {
        this.saveDeadline(null);
        this.deadline = null;
        this.stopInterval();
        this.updateTimer();
      } else if (this.drawer?.hasAttribute('open')) {
        this.startCountdown();
      } else {
        this.deadline = this.readDeadline();
        this.updateTimer();
      }
    }

    startCountdown() {
      if (Number(this.dataset.cartCount) <= 0) return;
      this.deadline = this.readDeadline();
      if (!this.deadline) {
        this.deadline = Date.now() + (Number(this.dataset.duration) || 600) * 1000;
        this.saveDeadline(this.deadline);
      }
      this.updateTimer();
      if (this.deadline > Date.now() && !this.interval) {
        this.interval = setInterval(() => this.updateTimer(), 1000);
      }
    }

    updateTimer() {
      const output = this.querySelector('[data-cart-timer-value]');
      if (!output) return;
      if (!this.deadline) {
        output.textContent = '10:00 min';
        return;
      }
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (remaining === 0) {
        output.textContent = this.dataset.expired;
        this.stopInterval();
        return;
      }
      output.textContent = `${Math.floor(remaining / 60)}:${String(remaining % 60).padStart(2, '0')} min`;
    }

    stopInterval() {
      clearInterval(this.interval);
      this.interval = null;
    }

    disconnectedCallback() {
      this.stopInterval();
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}
